import styled from 'styled-components'

export const contentFontSize = '15px'
export const commonButtonWidth = '140px'

export const StyledModal = styled.div`
  * {
    max-width: 100%;
    box-sizing: border-box;
  }
  .dropdown-container,
  .select__control {
    width: 100%;
    min-width: 0;
  }
  .btn-group {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
    margin-top: 1rem;
    padding-top: 1rem;
  }
  .location-actions {
    display: flex;
    justify-content: space-between;
    color: rgb(23, 59, 104);
  }
`
export const StyledLoader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(180, 180, 180, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 4px;
`
export const StyledDeliveryCard = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  background-color: #babcbe29;
  padding: 25px;
  border-radius: 5px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    padding: 15px;
    gap: 10px;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }

  img {
    width: 120px;
    height: 60px;
    object-fit: contain;

    @media (max-width: 1024px) {
      width: 90px;
      height: 47px;
    }

    @media (max-width: 768px) {
      width: 100px;
      height: 50px;
      margin-right: 10px;
    }

    /* Mobile phones */
    @media (max-width: 576px) {
      width: 90px;
      height: 45px;
      margin-bottom: 10px;
      margin-right: 0;
    }
  }

  .price-info {
    flex: 1;
    text-align: center;
    font-weight: bold;
    font-size: 16px;

    @media (max-width: 768px) {
      min-width: 100px;
      padding: 0;
      margin: 10px 0;
    }

    @media (max-width: 576px) {
      width: 100%;
      padding: 0;
    }
  }

  .radio-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @media (max-width: 768px) {
      margin-left: 5rem;
    }
    @media (max-width: 576px) {
      width: 100%;
      margin-left: 5rem;
      justify-content: flex-start;
    }
  }
`
